import {Pipe, PipeTransform} from '@angular/core';
import {Request} from '../../classes/request';
import {practiceFolderName} from '../../utils/dnsProblems';
import {iperPhaseLabelOf, iperProblemLabels} from '../../utils/iperProblems';

@Pipe({
    name: 'iperProblemFilter',
    pure: false
})
export class IperProblemFilterPipe implements PipeTransform {

    transform(requestList: Array<Request>,
              activeView: string,
              phaseFilterValues: string[],
              problemFilterValues: string[],
              notesFilterValue: string,
              folderNameFilterValue: string): any {
        if (!requestList || activeView !== 'iper') {
            return requestList;
        }

        const phase = phaseFilterValues || [];
        const problems = problemFilterValues || [];
        const notes = (notesFilterValue || '').trim().toLowerCase();
        const folder = (folderNameFilterValue || '').trim().toLowerCase();
        if (!phase.length && !problems.length && !notes && !folder) {
            return requestList;
        }

        return requestList.filter(request => {
            if (phase.length && !phase.includes(iperPhaseLabelOf(request))) {
                return false;
            }
            if (problems.length) {
                const labels = iperProblemLabels(request);
                if (!problems.every(problem => labels.includes(problem))) {
                    return false;
                }
            }
            if (notes && (request.Notes || '').toLowerCase().indexOf(notes) === -1) {
                return false;
            }
            return !folder || practiceFolderName(request).toLowerCase().indexOf(folder) !== -1;
        });
    }
}
